import CHRO_QSet from "./roleQuestionSets/CHRO_QuestionSet";
import HR_QSet from "./roleQuestionSets/HR_QuestionSet";
import Talent_QSet from "./roleQuestionSets/Talent_QuestionSet";
import Workforce_QSet from "./roleQuestionSets/Workforce_QuestionSet";
import IT_QSet from "./roleQuestionSets/IT_QuestionSet";

import None from "./roleQuestionSets/CHRO_QuestionSet";

const QuestionSets = {
  "Choose your role": None,
  "CHRO/HR Leader": CHRO_QSet,
  "HR Analyst": HR_QSet,
  "VP Talent Acquisition": Talent_QSet,
  "VP Workforce Intelligence": Workforce_QSet,
  "HR IT": IT_QSet,
};

export default QuestionSets;
